









































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FView } from '@/core/FView';
import { DataType } from '@/core/data/DataType.ts'
import App from '@/App.vue';

import { DashboardTabs } from '@/components/tabs/DashboardTabs';
import { DashboardTabWrapper } from '@/components/tabs/DashboardTabWrapper';
import Loading from '@/components/Loading.vue';
import { DataContainer } from '@/core/data/DataContainer';
import { Common } from '@/core/Common';
import moment from 'moment';
import { Settings } from '@/core/Settings';
import { DataPeriod } from '@/core/data/DataPeriod';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { Downloader } from '@/core/Downloader';
import PlaceSelector from '@/components/PlaceSelector.vue';
import { Place } from '@/core/data/company/Place';
import { ReportConfig } from '@/core/ReportConfig';

@Component ({
  components: {
    PlaceSelector,
    Loading,
    VuePerfectScrollbar,
  }
})
export default class Dashboard extends Vue {
  public static allVisitorsItem: string = "show_all";

  private tabs: DashboardTabWrapper[] | null = null;
  private tabWrapper: DashboardTabWrapper | null = null;
  private tabView: any = Loading;
  private selectedTabIndex: number = -1;
  private datePickerTrigger: boolean = false;
  private canDownloadPDF: boolean = true;

  private newRangeStart!: string;
  private newRangeEnd!: string;
  private lastSelectedDate!: string;

  dateOneSelected(val: string) {
    this.newRangeStart = val;
    if (val != "") {
      this.lastSelectedDate = val;
    }
  }

  dateTwoSelected(val: string) {
    this.newRangeEnd = val;
    if (val != "") {
      this.lastSelectedDate = val;
    }
  }

  getCurrentRangeStr() {
    let range = this.getCurrentRange();
    if (range.start != range.end) {
      return this.formatDate(range.start) + " − " + this.formatDate(range.end);
    } else {
      return this.formatDate(range.start);
    }
  }


  getScrollSettings() {
    return Common.GetScrollSettings();
  }

  getCurrentRange() {
    return FView.Get().dataManager.GetCurrentRange();
  }

  getWholeRange() {
    return FView.Get().dataManager.GetWholeRange();
  }

  canSelectSingle() {
    return FView.Get().dataManager.GetPlace().company.periodMin == 1;
  }

  formatDate(date: string) {
    return Common.FormatDate(date);
  }

  updateRange() {
    let dateFrom = moment(this.newRangeStart);
    let dateTo   = moment(this.newRangeEnd);

    if (this.canSelectSingle() && (dateFrom.isAfter(dateTo) || this.newRangeStart == "" || this.newRangeEnd == "")) {
      this.newRangeStart = this.lastSelectedDate;
      this.newRangeEnd = this.lastSelectedDate;
      dateFrom = dateTo = moment(this.lastSelectedDate);
    }

    let days = dateTo.diff(dateFrom, 'days') + 1;
    let periodMin = FView.Get().dataManager.GetPlace().company.periodMin;

    if (days >= periodMin && days <= Settings.PeriodMaxDays) {
      this.getApp().SwitchLoadingState();
      FView.Get().dataManager.SelectRange(new DataPeriod(this.newRangeStart, this.newRangeEnd))
        .then(_ => this.getApp().SwitchReadyState())
        .catch(e => this.getApp().showError(e));
    } else {
      this.getApp().showError(`Длина периода должна быть не менее ${periodMin} и не более ${Settings.PeriodMaxDays} дней!`);
    }
  }

  placeChanged(place: Place) {
    let res = FView.Get().dataManager.SelectPlace(place);

    if (res == null) {
      this.refreshCurrentTab();
    } else {
      this.getApp().SwitchLoadingState();
      res.then(_ => this.getApp().SwitchReadyState()).catch(e => this.getApp().showError(e));
    }
  }

  refreshCurrentTab() {
    let lastScroll = this.getScroll();
    this.tabView = null;
    this.$nextTick(() => {
      this.displayTab(this.selectedTabIndex, true);
      this.$nextTick(() => {
        this.setScroll(lastScroll);
      });
    });
  }

  toggleDatePicker() {
    this.datePickerTrigger = !this.datePickerTrigger;
  }

  getPDF() {
    if (this.canDownloadPDF) {
      this.canDownloadPDF = false;
      
      let dataMgr = FView.Get().dataManager;
      let conf = Base64.encode(JSON.stringify(<ReportConfig>{
        from: dataMgr.GetCurrentRange().start,
        to: dataMgr.GetCurrentRange().end,
        company: dataMgr.GetPlace().company.id,
        place: dataMgr.GetPlace().name,
      }));
      
      let dateFrom = Common.FormatDate(dataMgr.GetCurrentRange().start);
      let dateTo = Common.FormatDate(dataMgr.GetCurrentRange().end);
      let reportName = `report_${dataMgr.GetPlace().getFullName()}_${dateFrom}-${dateTo}.pdf`;

      let address = FView.Get().apiManager.getAddress("get_pdf", { "conf": conf });
      Downloader.DownloadFile(address, true, reportName).finally(() => this.canDownloadPDF = true);
    }
  }



  created() {
    this.displayTab(DashboardTabs.GetDisplayedTab(this.getDisplayedTabs()));
  }

  getDisplayedTabs() : DashboardTabWrapper[] {
    if (this.tabs == null) {
      this.tabs = DashboardTabs.GetAvailable();
    }
    return this.tabs;
  }

  isSelected(index: number) : boolean {
    return this.selectedTabIndex == index;
  }

  displayTab(index: number, force: boolean = false) {
    if (index < this.getDisplayedTabs().length) {
      if (this.selectedTabIndex != index || force) {
        if (this.tabWrapper != null) {
          this.tabWrapper.onClosed();
        }

        this.selectedTabIndex = index;

        this.tabWrapper = this.getDisplayedTabs()[index];
        this.tabView = this.tabWrapper.component;
        this.tabWrapper.onDisplayed();

        this.setScroll(0);
      }
    } else {
      this.getApp().showError("Нет вкладок для отображения!");
      this.tabView = null;
    }
  }

  setScroll(value: number) {
    if (this.$el != null) {
      (this.$el.querySelector(".scrollable") as Element).scrollTop = value;
    }
  }

  getScroll() {
    if (this.$el != null) {
      return (this.$el.querySelector(".scrollable") as Element).scrollTop;
    }
    return 0;
  }

  logoutClicked() {
    let app: App = this.getApp();
    app.SwitchLoadingState();

    if (this.tabWrapper != null) {
      this.tabWrapper.onClosed();
    }

    FView.Get().authManager.Logout()
      .catch(err => this.getApp().showError(err))
      .finally(() => app.SwitchLoginState());
  }

  private getApp() : App {
    return this.$parent as App;
  }
}

